fx.ns("models", class Album extends fx.Model {

	constructor(data)
	{
		super(data);
	}

    get selectedPhotos()
    {
        let photos = [];
        for ( let i = 0; i < this.photos.length; i++)
        {
            let photo = this.photos.getItemAt(i);
            if (photo.selected)
                photos.push( photo );
        }

        return photos;
    }
});